import AudioVisualizerComponent from './audio-visualizer.component'

export default AudioVisualizerComponent
